import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function NoEmailSelected() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full grow items-center justify-center p-4">
      <div className="flex flex-col items-center justify-center gap-4">
        <Mail className="text-primary-500 h-8 w-8" />

        <div className="flex flex-col items-center justify-center gap-1">
          <h1 className="text-center">{t('FALLBACK_NO_EMAIL_TITLE')}</h1>

          <p className="text-muted-foreground flex gap-0.5 text-center text-sm">
            {t('FALLBACK_NO_EMAIL_HINT')}
          </p>
        </div>
      </div>
    </div>
  );
}
